import en from '@/locales/en';
import es from '@/locales/es';
import ru from '@/locales/ru';

import type { Language } from './languages';

// Every i18next namespace with its English bundle: the source of typed t() keys (src/i18next.d.ts).
// `common` is bundled here; a component adds its own namespace next to its registerLocaleResources call:
//     declare module '@/modules/i18n/namespaces' {
//         interface LocaleNamespaces { CookBookPage: typeof en }
//     }
export interface LocaleNamespaces {
    common: typeof en.common;
}

// `satisfies` keeps every language in sync with the English keys
export const resources = { en, es, ru } satisfies Record<Language, Pick<LocaleNamespaces, 'common'>>;
